import normalizeReservation from './normalizeReservation';

const fetchReservation = ({ v3ServicesPath, modelPath, transactionId }) => {
  const reservationUrl = `${v3ServicesPath}/reservation/${modelPath}/${transactionId}`;
  return fetch(reservationUrl)
    .then((res) =>
      res.json().then((data) => {
        return { ...data, status: res.status };
      })
    )
    .then(normalizeReservation);
};

export default fetchReservation;
